import { call, put, takeLatest } from "redux-saga/effects";
import { actions } from "./slice";
import * as API from "../../../../../services/apis";

export function* handleFetchClients({ payload }) {
  try {
    const res = yield call(API.fetchCompaniesForFilter, payload);
    const { data } = res;
    yield put(actions.fetchClientsSuccess(data));
  } catch (err) {
    yield put(actions.fetchClientsFailure(err?.response?.data));
  }
}

export function* handleFetchProjects({ payload }) {
  try {
    const res = yield call(API.fetchProjectCodesForFilters, payload?.query);
    const { data } = res;
    yield put(actions.fetchProjectsSuccess(data));
  } catch (err) {
    yield put(actions.fetchProjectsFailure(err?.response?.data));
  }
}

export function* handleFetchCommodities({ payload }) {
  try {
    
    const res = yield call(API.fetchAllCommoditiesForLab, payload);
    const { data } = res;
    yield put(actions.fetchCommoditiesSuccess(data));
  } catch (err) {
    yield put(actions.fetchCommoditiesFailure(err?.response?.data));
  }
}

export function* handleFetchTestingTypes({ payload }) {
  try {
    
    const res = yield call(API.fetchAllTestCategories, payload);
    const { data } = res;
    yield put(actions.fetchTestingTypesSuccess(data));
  } catch (err) {
    yield put(actions.fetchTestingTypesFailure(err?.response?.data));
  }
}

/**
 * Root saga manages watcher lifecycle
 */
export function* dashboardFiltersSaga() {
  yield takeLatest(actions.fetchClients.type, handleFetchClients);
  yield takeLatest(actions.fetchProjects.type, handleFetchProjects);
  yield takeLatest(actions.fetchCommodities.type, handleFetchCommodities);
  yield takeLatest(actions.fetchTestingTypes.type, handleFetchTestingTypes);
}